<template>
  <div class="bd-t-black p-y-3">
    <div class="container">
      <p class="h5 m-b-2">Share your address when you're ready</p>
      <p>We don't give Pro Referral pros your address. When you connect with your matched pros,
      they may ask your address while you discuss your project details.
      Sharing this information is at your discretion.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'share-address',
};
</script>
